import React from 'react';
import man from "../Assets/illustration-people-2.svg";
import path from "../Assets/path-1.svg";
import leaf from "../Assets/leaf-2.svg";
import leaf1 from "../Assets/leaf-1.svg";
import tree from "../Assets/tree2.svg";
import snail from "../Assets/snail.svg";

import { Parallax, ParallaxProvider } from 'react-scroll-parallax';

const Come = () => {
  return (
    <ParallaxProvider>
      <div className='max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='text-[#0a3039]'>
          <Parallax translateX={[5, -5]} className='text-[40px] sm:text-[60px] md:text-[100px] lg:text-[220px] sensei-text pl-4 md:pl-12'>
            <strong>Come</strong>
          </Parallax> 
          <div className='relative w-full mt-4'>
            <div className='flex flex-col-reverse lg:flex-row items-center'>
              {/* Left Section */}
              <div className='w-full lg:w-[40%] flex justify-center lg:justify-end p-4'>
                <Parallax translateX={[-25, 25]}>
                  <img src={man} alt="man" className='w-[60%] sm:w-[70%] md:w-[80%] lg:w-auto max-w-xs' />
                </Parallax>
              </div>

              {/* Right Section */}
              <div className='w-full lg:w-[60%] px-4'>  
                <h1 className='text-xl sm:text-[#16bab1]xl md:text-[#16bab1]xl lg:text-5xl font-bold mb-4 navbar-link text-[#16bab1]enter lg:text-left'>
                  over and look around.
                </h1>
                <p className='font-sans mb-4 text-sm sm:text-base lg:text-lg text-justify'>
                Every stage is designed to meet the child’s developmental needs, creating a safe, engaging, and home-like environment where they thrive.Join us as we shape young minds with love, care, and a passion for learning!
                </p>

                <div className='flex flex-col sm:flex-row justify-center lg:justify-start items-center mt-6 space-y-4 sm:space-y-0 sm:space-x-4'>
                  <button className="px-4 md:px-6 lg:px-8 py-2 bg-[#16bab1] text-white rounded-md shadow-lg">
                    Schedule a Tour
                  </button>
                  <span className='text-[#16bab1] sm:mx-2'>or</span>
                  <button className="px-4 md:px-6 lg:px-8 py-2 border border-[#16bab1] text-[#16bab1] rounded-lg transition">
                    Join Our New Session
                  </button>
                </div>
              </div>
            </div>

            {/* Decorative Images */}

<img src={leaf}  alt="leaf"  className='absolute bottom-0 left-6 h-8 sm:h-10 md:h-12 lg:h-16' />
<img src={leaf1} alt="leaf1" className='absolute bottom-2 md:-bottom-10 left-20 sm:left-28 h-12 sm:h-16 md:h-24 lg:h-36' />
<img src={tree}  alt="tree" className='absolute bottom-0 right-4 h-20 sm:h-28 md:h-36 lg:h-auto' />
<img src={path}  alt="path" className='rotate-0 md:-rotate-6 absolute w-full -mt-6 sm:-mt-8 md:-mt-12' />

            {/* Contact Details */}
            <div className='absolute font-bold  font-sans   md:z-0 z-30 flex flex-col md:flex-row md:justify-between mx-auto left-0 md:left-[50px] lg:left-[100px] bottom-[-210px] sm:bottom-[-150px] lg:bottom-[-130px] navbar-link text-[#16bab1]enter md:text-left space-y-4 sm:space-y-0 sm:space-x-0 lg:space-x-12'>
              <p className='text-[#0a3039] text-sm sm:text-base md:text-md lg:text-xl'>
                TamilNadu,<br />  
                India
              </p>
              <p className='text-[#0a3039] text-sm sm:text-base md:text-lg lg:text-xl'>
                23, New Sankaranpalayam Road,<br />
                Near Tollgate, Vellore - 632001
              </p>
              <p className='text-[#0a3039] text-sm sm:text-base md:text-lg lg:text-xl'>
                Phone:<br />  
                99945 58487
              </p>
              <p className='text-[#0a3039] text-sm sm:text-base md:text-lg lg:text-xl'>
                Email:<br />
                kidsofkalam@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='wave mt-24 sm:mt-32 relative'>
        <Parallax translateX={[25, -25]} className='absolute left-12 sm:left-20 lg:left-72 top-2'>
          <img src={snail} alt="snail" className='w-8 sm:w-10 md:w-12 lg:w-auto' />
        </Parallax>
      </div>
    </ParallaxProvider>
  );
};

export default Come;
